import React from "react";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import "./commonTabStrip.scss";

/**
 * Common TabStrip component that can be reused across the application
 * @param {Object} props
 * @param {Array} props.tabs - Array of tab configurations
 * @param {number} props.selectedTab - Currently selected tab index
 * @param {Function} props.onTabSelect - Callback function when tab is selected
 * @param {string} props.contentClassName - Optional class name for tab content
 * @param {boolean} props.animation - Whether to animate tab transitions (default: true)
 */
const CommonTabStrip = ({ tabs, selectedTab, onTabSelect, contentClassName = "", animation = true, tabStripProps = {} }) => {
  return (
    <div className='common-tab-strip'>
      <TabStrip selected={selectedTab} onSelect={onTabSelect} animation={animation} {...tabStripProps}>
        {tabs.map((tab, index) => (
          <TabStripTab key={index} title={tab.title} contentClassName={contentClassName}>
            <div className='common-tab-strip-content'>{tab.content}</div>
          </TabStripTab>
        ))}
      </TabStrip>
    </div>
  );
};

export default CommonTabStrip;
